﻿export default {
    name: 'wizard',
    props: ['wizardHeadings', 'isSubmitting', 'skipSubmissionForCurrentPanel', 'canMoveToNextPanel', 'resetWizard', 'showDoneButton'],
    emits: ["stepCompletePrevious", "stepCompleteNext", "beginSubmission", "wizardComplete"],
    data() {
        return {
            step: 1,
            startSubmit: false,
            maxWizardItems: 4,
            nextClickedAwaitingSubmission: false,
            moveToNextPanel: false
        };
    },
    methods: {
        previousStep() {
            if (this.step > 1) {
                this.step--;
                this.$emit("stepCompletePrevious", this.step);
                this.updateCurrentWizardPanel();
                this.moveToNextPanel = true;
            }
        },
        nextStep() {
            console.log("canMoveToNextPanel", this.canMoveToNextPanel);
            if (this.moveToNextPanel) {
                if (this.step < this.wizardHeadings.length) {
                    this.step++;
                    this.$emit("stepCompleteNext", this.step);
                    this.updateCurrentWizardPanel();
                    //this.moveToNextPanel = false;
                }
            }
            
        },
        updateCurrentWizardPanel(){
            $('.wizard-content').children().hide();
            $('.wizard-content [step-id=' + this.step + ']').show();
        },
        beginSubmission() {
            console.log("Next clicked");
            if (this.skipSubmissionForCurrentPanel) {
                this.nextStep();
            }
            else {
                this.nextClickedAwaitingSubmission = true;
                this.$emit("beginSubmission", this.step);
            }
            
        },
        done(){
            this.$emit("wizardComplete", true);
        }
    },
    computed: {
        
    },
    mounted: function () {
        this.updateCurrentWizardPanel();
    },
    watch: {
        isSubmitting: {
            handler: function () {
                console.log("isSubmitting", this.isSubmitting);
                if (!this.isSubmitting && this.nextClickedAwaitingSubmission) {
                    this.nextClickedAwaitingSubmission = false;
                    this.nextStep();
                }
            },
            immediate: true,
            deep: true
        },
        resetWizard:{
            handler: function(){
                console.log("resetWizard", this.resetWizard);
                if(this.resetWizard){
                    this.step = 1;
                    this.updateCurrentWizardPanel();
                }
            },
            immediate: true,
            deep: true
        },
        // stepNumber:{
        //     handler: function () {
        //         if(this.stepNumber){
        //             this.step = this.stepNumber;
        //         }
                
        //     },
        //     immediate: true,
        //     deep: true
        // },
        canMoveToNextPanel: {
            handler: function () {
                this.moveToNextPanel = this.canMoveToNextPanel;
                console.log("moveToNextPanel", this.moveToNextPanel);
            },
            immediate: true,
            deep: true
        }
    }
};